export const FETCH_PARKING_STATIONS_SUCCESS = "FETCH_PARKING_STATIONS_SUCCESS";
export const FETCH_PARKING_STATIONS_FAIL = "FETCH_PARKING_STATIONS_FAIL";
export const FETCH_PARKING_STATIONS_LOADING = "FETCH_PARKING_STATIONS_LOADING";

export const FREE_PARKING_STATION_LOADING = "FREE_PARKING_STATION_LOADING";
export const FREE_PARKING_STATION_SUCCESS = "FREE_PARKING_STATION_SUCCESS";
export const FREE_PARKING_STATION_FAIL = "FREE_PRAKING_STATION_FAIL";
